export default __webpack_public_path__ + "static/media/carousel3.69e66504.jpeg";